  $('.sub_box_01').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0%",
      autoplay: true,
      arrows: true,
      dots: false,

      responsive: [{
          breakpoint: 768, // ブレイクポイントを指定
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: true,
              centerMode: true,
              centerPadding: "14%",
              infinite: true,
              autoplay: true,
          },
      }, ]
  });